"use client";

import { createContext } from "react";

export * from "@workspace/gamja-platform/components/article-shell/ArticleShellContext";

/** Space above the JCG learning tools; the video iframe stays in the article. */
export const ArticleVideoDockContext = createContext<HTMLElement | null>(null);
